<div class="wrapper">
  <div *ngIf="!confirmedAt">
    <ng-container *ngIf="!showUpdateEmail">
      <div class="font-semibold">
        Email status → 🟡 Waiting for email confirmation...
      </div>

      <p>
        <!-- Click the link we sent your email ({{ email | slice: 0 : 2 }}***@{{
          email | slice: email.indexOf('@') + 1
        }}). Check your Promotions & Spam folder if you don’t see it right away.
        Not your email? -->
        Click the link we sent your email ({{ email }}). Check your Promotions &
        Spam folder if you don’t see it right away. Not your email?
        <span
          (click)="showUpdateEmail = true"
          class="underline text-primary-500 cursor-pointer"
          >Update it</span
        >.
      </p>
      <p>
        The link in your email will open in a new tab. Close the tab and you’re
        in!
      </p>

      <p class="font-semibold">
        Can't find the email?

        <ng-container *ngIf="sending">
          <span class="underline">Sending</span> new confirmation email...
        </ng-container>

        <span
          *ngIf="!sending"
          (click)="requestNewLink()"
          class="text-primary-500 cursor-pointer underline"
        >
          Click here to request a new verification email.
        </span>
      </p>
    </ng-container>

    <ng-container *ngIf="showUpdateEmail">
      <app-verify-identity-email-update
        [currentEmail]="email"
        (closeEmailUpdate)="showUpdateEmail = false"
      ></app-verify-identity-email-update>
      <div
        (click)="showUpdateEmail = false"
        class="mt-4 underline cursor-pointer"
      >
        Cancel email update.
      </div>
    </ng-container>
  </div>

  <div *ngIf="!!confirmedAt">
    <div class="font-semibold">Email status → ✅ Email confirmed!</div>
    <p>
      You have successfully confirmed your email address. Waiting on phone
      verification.
    </p>
  </div>
</div>
